<script>
  // @ts-nocheck
  import { afterUpdate } from "svelte";
  import { menu } from "./menuMobile";
  import IconsMobile from "./IconsMobile.svelte";

  export let isOpen = true;
  // @ts-ignore
  const bodyScroll = {
    prevent() {
      // @ts-ignore
      document.querySelector("body").style.overflow = "hidden";
    },
    allow() {
      // @ts-ignore
      document.querySelector("body").style.overflow = null;
    },
  };

  $: {
    isOpen;
    afterUpdate(() => {
      isOpen ? bodyScroll.prevent() : bodyScroll.allow();
    });
  }
  /**@type {Object[] | ??}*/
  let submenu;
  /**@type {HTMLDialogElement}*/
  let sub;

  /**@param {string}main*/
  const openSubmenu = (main) => {
    submenu = menu.find((item) => item.main == main);
    if (submenu) {
      sub.showModal();
    }
  };
  const closeAll = () => {
    sub.close();
    isOpen = false;
  };
</script>

<div class="navigation-container">
  <nav>
    {#each menu as route, step}
      {#if route.main == "BEST SELLERS"}
        <li>
          <a class="main" on:click={closeAll} href={route.submenu[0].link}
            >{route.submenu[0].name}</a
          >
        </li>
      {:else}
        <li>
          <button class="main" on:click={() => openSubmenu(route.main)}>
            {route.main}
          </button>
        </li>
      {/if}
    {/each}
  </nav>
  <div class="icons-container">
    <IconsMobile bind:isOpen />
  </div>
  <dialog bind:this={sub}>
    {#if submenu}
      <ul class="submenu">
        <button on:click={() => sub.close()}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 97 97"
          >
            <defs>
              <clipPath id="clip-path">
                <rect
                  id="Rectángulo_1417"
                  data-name="Rectángulo 1417"
                  width="97"
                  height="97"
                  transform="translate(0.054 0.053)"
                  fill="#fff"
                  stroke="var(--freeShipping)"
                  stroke-width="1"
                />
              </clipPath>
            </defs>
            <g transform="translate(-0.054 -0.054)">
              <g transform="translate(21.516 0)">
                <path
                  fill="var(--freeShipping)"
                  data-name="Trazado 10283"
                  d="M52.6,88.783,11.772,47.958,51.458,8.278A4.848,4.848,0,1,0,44.6,1.422L2.176,43.842a4.594,4.594,0,0,0-.764.624,5.022,5.022,0,0,0,.006,6.989,4.983,4.983,0,0,0,.764.624L45.742,95.639A4.85,4.85,0,1,0,52.6,88.783Z"
                  transform="translate(0 -0.004)"
                />
              </g>
            </g>
          </svg>
          <span>
            {submenu.main}
          </span>
        </button>
        <div class="submenu over-scroll">
          {#each submenu.submenu as menu}
            <li>
              <a on:click={closeAll} href={menu.link}>{menu.name}</a>
            </li>
          {/each}
        </div>
      </ul>
    {/if}
  </dialog>
</div>

<style>
  button {
    background-color: transparent;
    border: none;
    color: var(--secondary-color);
  }
  .navigation-container {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 0 0 20px 0;
  }
  nav {
    width: 100%;
    height: 100%;
    list-style: none;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 5%;
    align-items: center;
    overflow: hidden;
    padding: 30px 0;
  }
  nav li {
    width: 100%;
  }
  .main {
    width: 90%;
    text-align: left;
    font-size: clamp(1.5rem, 10svw, 2rem);
    padding: 0 20px;
    font-family: "gotham-medium";
    text-decoration: none;
  }
  .icons-container {
    width: 100%;
    height: 50%;
  }
  dialog {
    display: block;
    width: 100svw;
    height: calc(100svh - (var(--header-height) + 34px));
    max-width: inherit;
    max-height: inherit;
    inset-inline-start: inherit;
    inset-inline-end: inherit;
    position: fixed;
    z-index: 9999999;
    top: inherit;
    left: 0;
    bottom: 0;
    opacity: 0;
    background-color: #f6f6f6;
    transition: all 300ms ease !important;
    /* transition-delay: 400ms;} */
    transform: translateX(-100%);
    animation: closeModal 300ms ease forwards;
  }
  dialog[open] {
    animation: openModal 300ms ease forwards;
  }
  @keyframes openModal {
    from {
      opacity: 0;
      transform: translateX(-100%);
    }
    to {
      opacity: 1;
      transform: translateX(0%);
    }
  }
  @keyframes closeModal {
    from {
      opacity: 1;
      transform: translateX(0%);
    }
    to {
      opacity: 0;
      transform: translateX(-100%);
    }
  }
  dialog::backdrop {
    display: none;
  }
  .submenu {
    width: 100%;
    height: 90%;
    display: flex;
    flex-direction: column;
    padding: 20px 20px 0 20px;
    list-style: none;
    gap: 35px;
    overflow: hidden;
  }
  .over-scroll {
    padding: 0 0 30px 46px;
    overflow-y: auto;
    scrollbar-width: none;
    gap: 25px;
  }
  .over-scroll::-webkit-scrollbar {
    width: 0;
  }
  .submenu button {
    width: 100%;
    text-align: left;
    font-family: "gotham-medium";
    color: var(--freeShipping);
    display: flex;
    align-items: center;
    gap: 20px;
    margin-left: -5px;
    padding: 2px 0;
  }
  .submenu button svg {
    width: 22px;
    height: 22px;
  }
  .submenu button span {
    font-size: clamp(1.5rem, 10svw, 2rem);
    line-height: 0.8;
    margin-top: 1px;
  }
  .submenu a {
    font-size: clamp(1rem 5svw, 1.25rem);
    text-decoration: none;
  }

  @media (max-width: 375px) {
    .navigation-container {
      height: 90%;
    }
    nav {
      padding: 0;
    }
    .main {
      font-size: 1.7rem;
    }
  }
</style>
